import { put, takeLatest } from 'redux-saga/effects'
import { Theme } from '../../global/types'
import {
  addLandingPage,
  addTheme,
  CREATE_LANDING_PAGE,
  CREATE_LANDING_PAGE_FAIL,
} from './actions'
import { createLandingPage as createLandingPageAPI } from './api'

const snakeToCamel = (str: string) =>
  str.replace(/([-_][a-z])/g, group =>
    group.toUpperCase().replace('-', '').replace('_', ''),
  )

const deserializer = resource => {
  const newResource = {}

  Object.keys(resource).forEach(value => {
    newResource[snakeToCamel(value)] = resource[value]
  })

  return newResource
}

export function* createLandingPage(action) {
  try {
    const { countryId, name, path } = action
    const response = yield createLandingPageAPI(countryId, name, path)
    const theme = deserializer(response.theme)
    yield put(addTheme(theme as Theme))
    yield put(
      addLandingPage({
        ...deserializer(response),
        theme: theme.id,
      }),
    )
  } catch (error) {
    console.error(error)
    yield put({ type: CREATE_LANDING_PAGE_FAIL, message: error.message || '' })
  }
}
export function* rootSaga() {
  yield takeLatest(CREATE_LANDING_PAGE, createLandingPage)
}
